import axios from 'axios';
import { API_BASE_URL } from '@config';
import * as ActionsDialog from 'app/store/actions';
import { showMessage } from 'app/store/actions/fuse';
import { getClusters } from '../../../cluster/store/actions';

// SET


export const SET_CREDENTIALS_LIST = 'SET_CREDENTIALS_LIST';
export const setCredentialList = credentials => ({
	type: SET_CREDENTIALS_LIST,
	payload: credentials
});

export const SET_CREDENTIAL = 'SET_CREDENTIAL';
export const setCredential = credential => ({
	type: SET_CREDENTIAL,
	payload: credential
});

export const SET_SELECTED = 'SET_SELECTED';
export const setSelected = credential => ({
	type: SET_SELECTED,
	payload: credential
});

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const setSearchText = event => ({
	type: SET_SEARCH_TEXT,
	searchText: event.target.value
});

export const SET_CREDENTIAL_ERROR = 'SET_CREDENTIAL_ERROR';
export const setCredentialError = error => ({
	type: SET_CREDENTIAL_ERROR,
	payload: error
});

// CLEAR
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const clearError = () => ({
	type: CLEAR_ERROR
});

export const CLEAR_CREDENTIAL = 'CLEAR_CREDENTIAL';
export const clearCredential = () => ({
	type: CLEAR_CREDENTIAL
});

export const CLEAR_CREDENTIALS_REDUCER = 'CLEAR_CREDENTIALS_REDUCER';
export const clearCredentialsReducer = () => ({
	type: CLEAR_CREDENTIALS_REDUCER
});

// * ////////////// HEADERS ////////////// * //
const headers = {
	headers: {
		admin: true
	}
};

// * ////////////// NEW ////////////// * //

export const newCredential = () => dispatch => {
	const data = {
		name: '',
		description: '',
		provider: '',
		data: {}
	};
	dispatch(setCredential(data));
};

// * ////////////// GET ////////////// * //

export const getCredentials = (showLoadingIndicator = false) => dispatch => {
	if (showLoadingIndicator) dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/credentials/`);
	return request
		.then(response => dispatch(setCredentialList(response.data)))
		.then(() => {
			if (showLoadingIndicator) dispatch(ActionsDialog.toggleLoading())
		})
		.catch(err => dispatch(setCredentialError({ ...err.data, type: 'modal' })));
};

export const getCredential = data => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/credentials/${data.id}`, headers);
	return request
		.then(response => {
			dispatch(setCredential(response.data));
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => {
			dispatch(setCredentialError(err.data));
			dispatch(ActionsDialog.toggleLoading());
		});
};

// * ////////////// POST ////////////// * //

export const saveCredential = credentials => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/credentials/`, { credentials }, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.closeDialog());
			dispatch(getCredentials(true));
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setCredentialError({ ...err.data, type: 'form' }));
		});
};

export const setToCluster = data => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/credentials/set`, data, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.closeDialog());
			dispatch(getCredentials(true));
			dispatch(getClusters());
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setCredentialError({ ...err.data, type: 'modal' }));
		});
};

// * ////////////// PUT ////////////// * //

export const editCollaborators = data => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/credentials/collaborators`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.credential));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getCredentials(true));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setCredentialError({ ...err.data, type: 'modal' }));
		});
};

// * ////////////// DELETE ////////////// * //

export const deleteCredential = id => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.delete(`${API_BASE_URL}/api/credentials/${id}`, headers);
	return request
		.then(() => dispatch(getCredentials(true)))
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'Credential Deleted' }));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setCredentialError({ ...err.data, type: 'modal' }));
		});
};
